import "./App.css";
import { Toaster } from "react-hot-toast";
import { UserCapabilityProvider } from "./components/ConstantReducerProvider";

import RootRouter from "./connector/RootRouter";
import { AppDataProvider } from "./components/AppDataContext";

function App() {
  return (
    <div>
      <UserCapabilityProvider>
        <AppDataProvider>
          <Toaster position="top-center" reverseOrder={true} />
          <RootRouter />
        </AppDataProvider>
      </UserCapabilityProvider>
    </div>
  );
}

export default App;
